import { ColorEnum } from '@enum/style/color.enum';

import { DividerStyleType } from './divider.style-type';

export const DividerDarkTheme: DividerStyleType = {
  mainColor: ColorEnum.Black40,
};
